<template>
  <div>
    <el-dialog
      title="签约授权"
      width="472px"
      :visible="visible"
      @close="$emit('update:visible', false)"
      append-to-body
      modal-append-to-body
    >
      <div id="info-verify">
        <div>
          <span>您是首次使用在线签约，请先完成实名认证。</span>
        </div>
        <el-form label-width="100px" class="m-t20">
          <el-form-item label="公司名称" v-if="showRange === 0 || showRange === 1">
            <div>{{ userCurrentOrg.name }}</div>
          </el-form-item>
          <el-form-item
            label="信用代码"
            prop="creditCode"
            v-if="showRange === 0 || showRange === 1"
          >
            <el-input
              v-model.trim="creditCode"
              clearable
              placeholder="请输入公司统一社会信用代码"
            ></el-input>
            <div class="info-query" @click="showInfo = true">
              <svg-icon icon-class="info"></svg-icon>
              <span>如何查询统一社会信用代码？</span>
            </div>
          </el-form-item>
          <el-form-item label="姓名" prop="name" v-if="showRange === 0 || showRange === 2">
            <el-input v-model.trim="name" clearable placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idNumber" v-if="showRange === 0 || showRange === 2">
            <el-input v-model.trim="idNumber" clearable placeholder="请输入您的身份证号"></el-input>
          </el-form-item>
          <!--        <el-form-item>-->
          <!--          <el-checkbox v-model="viewed">-->
          <!--            <span class="c-9">同意</span>-->
          <!--            <span class="c-red">《找钢网在线签约服务条款》</span>-->
          <!--          </el-checkbox>-->
          <!--        </el-form-item>-->
        </el-form>
      </div>
      <div class="operations">
        <el-button @click="$emit('update:visible', false)">取消</el-button>
        <el-button type="primary" @click="commit">确认提交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showInfo"
      @click="showInfo = false"
      width="600px"
      title="如何查询统一社会信用代码？"
      :modal="false"
      append-to-body
      modal-append-to-body
    >
      <div class="query-content c-3">
        <div>1、百度搜索启信宝、企查查、天眼查等第三方企业查询网站，点击进入；</div>
        <img src="~@/assets/sign/creditCode-1.jpg" alt="打开百度，搜索启信宝等" />
        <div>2、输入公司名称，点击搜索进行查询；</div>
        <img src="~@/assets/sign/creditCode-2.jpg" alt="输入公司名称，查询详情" />
        <div>3、在搜索结果中找到自己公司，进入详情页即可看到对应的统一社会信用代码。</div>
        <img src="~@/assets/sign/creditCode-3.jpg" alt="在详情中获取统一社会信用代码" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { validateIdCard, validateCreditCode } from '@/common/utils/validate.js'
import { mapGetters } from 'vuex'

export default {
  name: 'ZgRealNameVerify',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 需要录入的范围 包含姓名 身份证号 统一信用代码
    // 1: 统一信用代码 2：姓名身份证号
    // 0 则全部缺失
    showRange: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      creditCode: '',
      name: '',
      idNumber: '',
      showInfo: false,
      viewed: true
    }
  },
  computed: {
    ...mapGetters(['userCurrentOrg'])
  },
  methods: {
    async commit() {
      let result = this.verifyData()
      if (result) {
        this.$message.warning(result)
        return false
      }
      let { name, idNumber, creditCode } = this
      let param
      switch (this.showRange) {
        case 2:
          param = {
            legalName: name,
            legalIdentity: idNumber
          }
          break
        case 1:
          param = {
            csdCode: creditCode,
            name: this.userCurrentOrg.name
          }
          break
        case 0:
          param = {
            legalName: name,
            legalIdentity: idNumber,
            csdCode: creditCode,
            name: this.userCurrentOrg.name
          }
      }
      param.type = this.showRange === 0 ? 3 : this.showRange
      let { success, data } = await this.$post('contract.updateOrgInfo', {
        request: param
      })
      // TODO 确认是否要等待结果（轮询）
      if (success) {
        this.$message.warning('法人信息提交成功')
      }
      this.$emit('update:visible', false)
    },
    // 验证数据
    verifyData() {
      switch (this.showRange) {
        case 0: {
          if (!(this.name && this.idNumber && this.creditCode)) return '请填写完整所有信息'
          break
        }
        case 2: {
          if (!(this.name && this.idNumber)) return '请填写完整所有信息'
          break
        }
        case 1: {
          if (!this.creditCode) return '请填写完整所有信息'
          break
        }
      }
      if (this.idNumber !== '' && !validateIdCard(this.idNumber)) return '身份证号不正确'
      if (this.creditCode !== '' && !validateCreditCode(this.creditCode))
        return '统一信用代码不正确'
      return ''
    }
  }
}
</script>

<style lang="less" scoped>
.operations {
  text-align: right;
}
.query-content > * {
  margin-top: 15px;
}
</style>
